import React from 'react';
import { Link } from 'gatsby';

import SocialIcons from '../common/social-icons';

import '../../styles/site-footer.scss';
import banner from '../../../images/pdr-logo_2x.png';

const SiteFooter = (props) => (
  <footer role="contentinfo" className="site-footer">
    <div className="site-footer-contents">
      <div className="site-footer__details">
        <Link to="/">
          <img className="banner" src={banner} alt="The Public Domain Review" />
        </Link>
        <p>
          The Public Domain Review is registered in the UK as a Community Interest Company (#11386184), a category of company which exists primarily to benefit a community or with a view to pursuing a social purpose, with all profits having to be used for this purpose.
        </p>
        <p>
          We rely on donations from readers. Please consider <Link to="/support">supporting the project</Link> and becoming a <Link to="/support/friends">Friend of the PDR</Link>.
        </p>
      </div>
      <div className="site-footer__about-links">
        <ul className="footer-links padded">
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/about/masthead">Masthead</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          <li>
            <Link to="/about/submissions">Submissions</Link>
          </li>
        </ul>
      </div>
      <div className="site-footer__explore-links">
        <ul className="footer-links padded">
          <li>
            <Link to="/explore">Explore</Link>
          </li>
          <li>
            <Link to="/explore/indexed">PDR Index</Link>
          </li>
          <li>
            <Link to="/sources">Sources</Link>
          </li>
          <li>
            <Link to="/further-reading">Further Reading</Link>
          </li>
        </ul>
      </div>
      <div className="site-footer__pd-links">
        <ul className="footer-links padded">
          <li>
            <Link to="/what-is-the-public-domain">What is the Public Domain?</Link>
          </li>
          <li>
            <Link to="/rights-labelling-on-our-site">Rights Labelling</Link>
          </li>
          <li>
            <Link to="/reusing-material">Reusing Material</Link>
          </li>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms-and-conditions">Terms and Conditions</Link>
          </li>
        </ul>
      </div>
      <div className="site-footer__content-links">
        <ul className="footer-links padded">
          <li>
            <Link to="/essays">Essays</Link>
          </li>
          <li>
            <Link to="/collections">Collections</Link>
          </li>
          <li>
            <Link to="/series/conjectures/">Conjectures</Link>
          </li>
          <li>
            <Link to="/series/curators-choice/">Curator’s Choice</Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
        </ul>
      </div>
      <div className="site-footer__shop-links">
        <ul className="footer-links padded">
          <li>
            <Link to="/shop">Shop</Link>
          </li>
          <li>
            <Link to="/shop/pdr-press-books/">PDR Press</Link>
          </li>
          <li>
            <Link to="/shop/fine-art-prints">Prints</Link>
          </li>
          <li>
            <Link to="/shop-faq">Shop FAQ</Link>
          </li>
          <li>
            <Link to="/returns-policy">Returns Policy</Link>
          </li>
        </ul>
      </div>
      <div className="site-footer__follow-links">
        <div className="newsletter-block">
          <Link to="/subscribe" className="newsletter-button">Subscribe to Our Newsletter</Link>
        </div>
        <div className="social-icons">
          <SocialIcons />
        </div>
      </div>
      <div className="site-footer__buddies">
        <img
          srcSet="https://the-public-domain-review.imgix.net/banners/pantagruel-strip-1.webp 1440w,
                  https://the-public-domain-review.imgix.net/banners/pantagruel-strip-1-1000.webp 1000w,
                  https://the-public-domain-review.imgix.net/banners/pantagruel-strip-1-640.webp 640w"
          src="https://the-public-domain-review.imgix.net/banners/pantagruel-strip-1.webp"
          alt="Pantagruel figures in a row"
        />
        <img
          srcSet="https://the-public-domain-review.imgix.net/banners/pantagruel-strip-2.webp 1440w,
                  https://the-public-domain-review.imgix.net/banners/pantagruel-strip-2-1000.webp 1000w,
                  https://the-public-domain-review.imgix.net/banners/pantagruel-strip-2-640.webp 640w"
          src="https://the-public-domain-review.imgix.net/banners/pantagruel-strip-2.webp"
          alt="Pantagruel figures in a row"
        />
      </div>
    </div>
  </footer>
);

export default SiteFooter;
